import React from 'react';
import { ListenButton } from '../common/AudioGuide';

const overlay = {
  position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.5)', display: 'flex',
  justifyContent: 'center', alignItems: 'center', zIndex: 1000,
};
const box = {
  backgroundColor: 'white', borderRadius: '8px', padding: '2rem',
  width: '90%', maxWidth: '640px', maxHeight: '85vh', overflowY: 'auto',
  boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
};
const step = (bg, border) => ({
  display: 'flex', gap: '1rem', marginBottom: '1rem', padding: '1rem',
  backgroundColor: bg, borderRadius: '6px', border: `1px solid ${border}`,
});

export default function ProjectManagementHelpModal({ onClose }) {
  return (
    <div style={overlay}>
      <div style={box}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
          <h3 style={{ margin: 0, color: '#333' }}>Project Management</h3>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <ListenButton compact guideId="project-management-help" title="Project Management Help" />
            <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: '1.5rem', cursor: 'pointer', color: '#888' }}>×</button>
          </div>
        </div>

        <div style={{ color: '#555', lineHeight: 1.7 }}>
          <div style={step('#f8f9fa', '#e9ecef')}>
            <div style={{ fontSize: '1.5rem', flexShrink: 0 }}>1.</div>
            <div>
              <strong>Where a job comes from</strong><br />
              A job is created by pressing Award on an estimate (Admin → Estimates), or by + Create Project here for jobs with no bid in the portal. Award copies the estimate name, client, division, and disciplines onto the job and links the two.
            </div>
          </div>

          <div style={step('#f8f9fa', '#e9ecef')}>
            <div style={{ fontSize: '1.5rem', flexShrink: 0 }}>2.</div>
            <div>
              <strong>Manage: what you can change</strong><br />
              Job name, client, division, project type, disciplines, who is assigned and with what role, and the reminder e-mails. Job Number and Estimate # are shown but locked for everyone, because the job number is the key in trackers, time, MTO, and almost every other table, and typing a new estimate number would leave the old bid still marked awarded.
            </div>
          </div>

          <div style={step('#fff3cd', '#ffecb5')}>
            <div style={{ fontSize: '1.5rem', flexShrink: 0 }}>3.</div>
            <div>
              <strong>Wrong bid, right job number (superadmin)</strong><br />
              Open the job → Details → scroll to <em>Superadmin corrections</em> → <strong>Change linked estimate</strong>. Search the right estimate (dashes optional), pick it, type its number again, press Move the award. The job and everyone on it stay. The old estimate is un-awarded; the new one is marked awarded to this job; the people on the job are also given the new estimate.
            </div>
          </div>

          <div style={step('#f8d7da', '#f5c6cb')}>
            <div style={{ fontSize: '1.5rem', flexShrink: 0 }}>4.</div>
            <div>
              <strong>Wrong job number (superadmin, empty jobs only)</strong><br />
              Open the job → Details → <strong>Change job number</strong>. The portal first counts every table that holds this job. If anything beyond the job itself, its estimate link, people, and disciplines exists — tracker rows, time, MTO, anything — it refuses and lists the tables. That clean-up stays with someone who can work in the database. If the job is still empty, type the new number twice and the people stay on the job.
            </div>
          </div>

          <div style={step('#e8f5e9', '#c8e6c9')}>
            <div style={{ fontSize: '1.5rem', flexShrink: 0 }}>5.</div>
            <div>
              <strong>Who sees what</strong><br />
              Admins see every job and can Manage. Only superadmins see the Superadmin corrections box, Archive, Restore, and Delete. Every correction writes a line to Admin → Audit Log with the old and new values.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
